module.exports = __webpack_public_path__ + "media/images/official/top_about1-f23bb2e0a913575000363d59945eb07c.svg";